/**
 * @file 黄页
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {fetchGetDetail} from '../../actions/yellowAction';
import {Toast} from '@baidu/spui';
import './index.less';

let telImg = require('../../asset/img/yellowPage/zuoji.png');

export class YellowPage extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            pageData: []
        };
    }

    componentDidMount() {
        this.getInfo(this.props.match.params.id);
    }

    getInfo = id => {
        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            window['__abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.fetchGetDetail({
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign,
                id: id
            }).then(data => {
                if (data.code === 200) {
                    this.setState({
                        pageData: data.data
                    });
                } else {
                    Toast.display({
                        type: 'error',
                        info: data.message,
                        delay: 3500
                    });
                }

            });
        };

        this.props.history.push(`/yellow_page/${id}`);
    };

    render() {
        let id = this.props.match.params.id;
        let pageData = this.state.pageData;
        let yData = [ // 1=生活服务 2=金融媒体 3=购物休闲
            {id: '10', name: '公共热线', type: 1},
            {id: '11', name: '政务', type: 2},
            {id: '12', name: '银行', type: 2},
            {id: '13', name: '快递物流', type: 1},
            {id: '14', name: '租车代驾', type: 1},
            {id: '15', name: '证券保险', type: 2},
            {id: '16', name: '美食外卖', type: 3},
            {id: '17', name: '出行购票', type: 3},
            {id: '18', name: '医疗健康', type: 1},
            {id: '19', name: '电商购物', type: 3},
            {id: '20', name: '手机家电', type: 3},
            {id: '21', name: '酒店', type: 3},
            {id: '22', name: '旅游', type: 3},
            {id: '23', name: '休闲娱乐', type: 3},
            {id: '24', name: '新闻媒体', type: 2},
            {id: '25', name: '教育科研', type: 1}
        ];

        return (
            <div className={'YellowPage'}>
                <div className={'title'}>
                    常用号码
                </div>
                <div className={'tab'}>
                    <div className={'tab-item'}>
                        <div className={'left'}>生活服务：</div>
                        <div className={'right'}>
                            {yData.map((item, index) => {
                                let dom = null;

                                if (item.type === 1) {
                                    dom = <span
                                        key={index}
                                        className={id === item.id ? 'on' : ''}
                                        onClick={() => {
                                            this.getInfo(item.id);
                                        }}
                                    >
                                        {item.name}
                                    </span>;
                                }
                                return dom;
                            })
                            }
                        </div>
                    </div>
                    <div className={'tab-item'}>
                        <div className={'left'}>金融媒体：</div>
                        <div className={'right'}>
                            {yData.map((item, index) => {
                                let dom = null;

                                if (item.type === 2) {
                                    dom = <span
                                        key={index}
                                        className={id === item.id ? 'on' : ''}
                                        onClick={() => {
                                            this.getInfo(item.id);
                                        }}
                                    >
                                        {item.name}
                                    </span>;
                                }
                                return dom;
                            })
                            }
                        </div>
                    </div>
                    <div className={'tab-item'}>
                        <div className={'left'}>购物休闲：</div>
                        <div className={'right'}>
                            {yData.map((item, index) => {
                                let dom = null;

                                if (item.type === 3) {
                                    dom = <span
                                        key={index}
                                        className={id === item.id ? 'on' : ''}
                                        onClick={() => {
                                            this.getInfo(item.id);
                                        }}
                                    >
                                        {item.name}
                                    </span>;
                                }
                                return dom;
                            })
                            }
                        </div>
                    </div>
                </div>

                <div className={'pb40'}>
                    {
                        pageData.map((item, index) => {
                            return <div className={'res-list'} key={index}>
                                <div className={'top'}>
                                    <div
                                        className={'img-mod'}
                                        style={{backgroundImage: `url(${item.logourl || telImg})`}}/>
                                    <div className={'name'}>{item.name}</div>
                                    <div
                                        className={this.state[item.id] ? 'count link on' : 'count link'}
                                        onClick={() => {
                                            this.setState({
                                                [item.id]: !this.state[item.id]
                                            });
                                        }}
                                    >
                                        共{item.phone.length}项
                                    </div>
                                </div>
                                {
                                    this.state[item.id]
                                        ? <div className={'bot'}>
                                            {
                                                item.phone.map((item, index) => {
                                                    return <div className={'item'} key={index}>
                                                        {
                                                            item.label
                                                                ? <span>{item.label}</span>
                                                                : null
                                                        }

                                                        <span>{item.number}</span>
                                                    </div>;
                                                })
                                            }
                                        </div>
                                        : null
                                }


                            </div>;
                        })
                    }
                </div>


            </div>
        );
    }
}

YellowPage.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    fetchGetDetail: PropTypes.func
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        fetchGetDetail: (type, obj) => fetchGetDetail(dispatch, type, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(YellowPage));
